module.exports = __webpack_public_path__ + "img/person-check-fill.3e3eb1fc.svg";